import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DetailPaymentService {
  public storage: any;
  public currentTableMovementPage: number;
  public movementFilters: IMovementFilters = {
    currentMethods: null,
    currentStates: null,
    currentBranches: null,
    dateFrom: null,
    hourFrom: '00',
    minutesFrom: '00',
    dateTo: null,
    currentCashiers: null,
    hourTo: '23',
    minutesTo: '59',
    accreditationDateFrom: null,
    accreditationDateTo: null
  };

  resetStorageFilterParameters() {
    this.movementFilters = {
      currentMethods: null,
      currentStates: null,
      currentBranches: null,
      currentCashiers: null,
      dateFrom: null,
      dateTo: null,
      hourFrom: '00',
      minutesFrom: '00',
      hourTo: '23',
      minutesTo: '59',
      accreditationDateFrom: null,
      accreditationDateTo: null
    };
  }

  hasFilterValues(): boolean {
    // Ignorar valores por defecto de horas al verificar si hay filtros
    const defaultHourValues = ['00', '23', '59'];

    for (const key in this.movementFilters) {
      const value = this.movementFilters[key];

      // Ignorar horas por defecto
      if (typeof value === 'string' && defaultHourValues.includes(value)) {
        continue;
      }

      if (value !== null) {
        return true;
      }
    }
    return false;
  }
}

export interface IMovementFilters {
  currentMethods: number[];
  currentStates: number[];
  currentBranches: number[];
  currentCashiers: number[];
  dateFrom: Date;
  hourFrom: string;
  minutesFrom: string;
  dateTo: Date;
  hourTo: string;
  minutesTo: string;
  accreditationDateFrom: string;
  accreditationDateTo: string;
}
